import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import React from "react";
import DurationService from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

const EarliestMMXWindowStartDate = "2017/10/01";

export class MmxDashboardWidgetFilters extends React.Component<any, any> {
    protected selectedFilters: any = {};
    private granularityDisabled: boolean;

    constructor(props) {
        super(props);
        this.granularityDisabled = this.isGranularityDisabled({
            widgetDuration: this.props.widgetDuration,
        });
        this.selectedFilters = {
            filter: this.props.widgetFilters.filter,
            timeGranularity: this.getGranularityForDuration(this.props.widgetDuration),
        };
        this.props.changeFilter(this.getSelectedFilters());
    }

    private getGranularityForDuration(widgetDuration: string): string {
        if (this.granularityDisabled) {
            return "Monthly";
        }
        return widgetDuration === "28d" ? "Daily" : "Monthly";
    }

    public render() {
        return (
            this.props.widgetWebSource === devicesTypes.DESKTOP && (
                <div
                    key="dynamicFiltersContainer"
                    className="filters"
                >
                    <div
                        key="timeGranularityFilter"
                        className="dynamicFilter"
                    >
                        <h5>
                            <I18n>{`home.dashboards.wizard.filters.TimeGranularity`}</I18n>
                        </h5>
                        <StatefulDropdown
                            key="timeGranularity"
                            items={[
                                {
                                    key: "Daily",
                                    id: "Daily",
                                    text: "Daily",
                                    disabled: this.granularityDisabled,
                                },
                                {
                                    key: "Weekly",
                                    id: "Weekly",
                                    text: "Weekly",
                                    disabled: this.granularityDisabled,
                                },
                                { key: "Monthly", id: "Monthly", text: "Monthly" },
                            ]}
                            selectedId={this.selectedFilters.timeGranularity}
                            onSelect={this.onSelectTimeGranularity}
                        />
                    </div>
                </div>
            )
        );
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.widgetDuration !== this.props.widgetDuration) {
            this.granularityDisabled = this.isGranularityDisabled({
                widgetDuration: this.props.widgetDuration,
            });
            const nextGranularity = this.getGranularityForDuration(this.props.widgetDuration);
            if (this.selectedFilters.timeGranularity !== nextGranularity) {
                this.selectedFilters.timeGranularity = nextGranularity;
                this.props.changeFilter(this.getSelectedFilters());
            }
        }
    }

    private isGranularityDisabled({ widgetDuration }) {
        widgetDuration = DurationService.getDurationData(widgetDuration);
        return widgetDuration.raw.from.isBefore(new Date(EarliestMMXWindowStartDate));
    }

    private getSelectedFilters() {
        return Object.entries(this.selectedFilters).map(([name, value]) => ({ name, value }));
    }

    private onSelectTimeGranularity = (item) => {
        this.selectedFilters.timeGranularity = item.id;
        this.props.changeFilter(this.getSelectedFilters());
    };
}
